import { AbstractControl, ValidatorFn } from "@angular/forms";
import { TribunalOrigemService } from "src/app/service/carta-precatoria/tribunal-origem.service";
import { from, of } from 'rxjs';


export function isValidEmail(tribunalSelecionado: any): ValidatorFn {
    return (control: AbstractControl): { [key: string]: boolean } | null => {
      const email = control.value;
      let mascaraEmail = /\S+@\S+\.\S+/;
  
      if (mascaraEmail.test(email)) {
        // const dominioEmail = email.substring(email.indexOf("@") + 1);
  
        // Verifica se o e-mail termina com .jus.br
        if (email.endsWith('.jus.br')) {
          return null;
        } else {
          return { emailNotEndsWithJusBr: true };
        }

        // Implementação futura: Verificar se o e-mail é do domínio do tribunal selecionado
        /*
        if (tribunalSelecionado && dominioEmail === tribunalSelecionado) {
          return null;
        } else {
          return { emailNotFromSelectedTribunal: true };
        }
        */
      } else {
        return { emailNotValid: true };
      }
    };
  }